import { render, staticRenderFns } from "./CreateCloudAccountMenu.vue?vue&type=template&id=8b2db88e&"
import script from "./CreateCloudAccountMenu.vue?vue&type=script&lang=ts&"
export * from "./CreateCloudAccountMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CreateCloudAccountMenu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports